import { GET_ACTS_PRICE_PER_INSURER } from "api/dataProviderTypes";
import { ActsPricePerInsurerRequest } from "api/types";
import { useQuery } from "react-query";
import { getActsPriceInsurerByInsurer } from "services/acts";
import { IReturnType } from "types";

/**
 * Récupère les tarifs configurés pour un assureur donné via
 * {@code GET /acts-price-insurer/by-insurer/{insurerId}}.
 *
 * <p>Signature simplifiée (2026-05-26) : prend directement
 * l'{@code insurerId} en argument. La clé de cache react-query inclut
 * désormais l'id — auparavant elle était figée sur
 * {@code GET_ACTS_PRICE_PER_INSURER} seul, ce qui faisait que changer
 * d'assureur ne refetchait pas (bug latent, sans impact tant qu'on
 * n'avait qu'un assureur affiché).
 *
 * <p>{@code enabled} protège contre un fetch avec {@code insurerId == null}.
 */
const useGetActsPriceInsurer = (
  insurerId: number | null | undefined
): IReturnType<ActsPricePerInsurerRequest[]> => {
  const result: IReturnType<ActsPricePerInsurerRequest[]> = useQuery(
    [GET_ACTS_PRICE_PER_INSURER, insurerId],
    () => getActsPriceInsurerByInsurer(insurerId),
    {
      staleTime: Infinity,
      enabled: insurerId != null,
    }
  );

  return result;
};

export default useGetActsPriceInsurer;
